const WaveIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.77539 5.62478C3.77539 5.62478 6.90039 3.12478 10.6504 5.62478C14.4004 8.12478 17.5254 5.62478 17.5254 5.62478"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.77539 9.99978C3.77539 9.99978 6.90039 7.49978 10.6504 9.99978C14.4004 12.4998 17.5254 9.99978 17.5254 9.99978"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.77539 14.3748C3.77539 14.3748 6.90039 11.8748 10.6504 14.3748C14.4004 16.8748 17.5254 14.3748 17.5254 14.3748"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export { WaveIcon };
